module.exports = __webpack_public_path__ + "img/DSC_4362.fa6d24eb.jpg";